export class RegisterCitation {
    get id() {
        return this.registerCitationState.id;
    }
    get origin() {
        return this.registerCitationState.origin;
    }
    get request() {
        return this.registerCitationState.request;
    }
    get inRegistNumber() {
        return this.registerCitationState.inRegistNumber;
    }
    get outRegistNumber() {
        return this.registerCitationState.outRegistNumber;
    }
    get inDate() {
        return this.registerCitationState.inDate;
    }
    get outDate() {
        return this.registerCitationState.outDate;
    }
    get destination() {
        return this.registerCitationState.destination;
    }
    get agentId() {
        return this.registerCitationState.agentId;
    }
    get report() {
        return this.registerCitationState.report;
    }
    get thirdId() {
        return this.registerCitationState.thirdId;
    }
    get content() {
        return this.registerCitationState.content;
    }
    get userId() {
        return this.registerCitationState.userId;
    }
    get outPutLock() {
        return this.registerCitationState.outPutLock;
    }
    get expedientNumber() {
        return this.registerCitationState.expedientNumber;
    }
    set id(id) {
        this.registerCitationState.id = id;
    }
    set request(request) {
        this.registerCitationState.request = request;
    }
    set inRegistNumber(inRegistNumber) {
        this.registerCitationState.inRegistNumber = inRegistNumber;
    }
    set outRegistNumber(outRegistNumber) {
        this.registerCitationState.outRegistNumber = outRegistNumber;
    }
    set inDate(inDate) {
        this.registerCitationState.inDate = inDate;
    }
    set outDate(outDate) {
        this.registerCitationState.outDate = outDate;
    }
    set agentId(agentId) {
        this.registerCitationState.agentId = agentId;
    }
    set report(report) {
        this.registerCitationState.report = report;
    }
    set thirdId(thirdId) {
        this.registerCitationState.thirdId = thirdId;
    }
    set content(content) {
        this.registerCitationState.content = content;
    }
    set userId(userId) {
        this.registerCitationState.userId = userId;
    }
    set outPutLock(outPutLock) {
        this.registerCitationState.outPutLock = outPutLock;
    }
    set expedientNumber(expedientNumber) {
        this.registerCitationState.expedientNumber = expedientNumber;
    }
    constructor(registerCitationState) {
        this.registerCitationState = registerCitationState;
    }
    getState() {
        return this.registerCitationState;
    }
}
